// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__18HG0","placeholdersHeader":"styles_placeholdersHeader__1GoKq","editorStyle":"styles_editorStyle__3ZB-f","placeholdersBox":"styles_placeholdersBox__3KxDw"};